import { useMutation, useQuery, useQueryClient } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  CreateTaskApplicationRequest,
  UpdateTaskApplicationRequest,
} from './TaskApplication.types';
import {
  createTaskApplication,
  deleteTaskApplication,
  listTaskApplications,
  updateTaskApplication,
} from './TaskApplication.service';
import { useIntl } from 'react-intl';
import { notification } from 'antd';

export function useCreateTaskApplication() {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const mutation = useMutation(
    (obj: CreateTaskApplicationRequest) => createTaskApplication(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['taskApplications']);

        notification.success({
          message: intl.formatMessage({
            id: 'tasks.application.modal.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'tasks.application.modal.create.success.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateTaskApplication() {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const mutation = useMutation(
    (obj: UpdateTaskApplicationRequest) => updateTaskApplication(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['taskApplications']);

        notification.success({
          message: intl.formatMessage({
            id: 'tasks.application.modal.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'tasks.application.modal.update.success.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useTaskApplications(taskId?: number) {
  const query = useQuery(['taskApplications', taskId], () => {
    return listTaskApplications(taskId);
  });

  useServiceError(query.error);

  return query;
}

export function useDeleteTaskApplication() {
  const queryClient = useQueryClient();
  const intl = useIntl();
  const mutation = useMutation((id: number) => deleteTaskApplication(id), {
    onSuccess() {
      queryClient.invalidateQueries(['partApplications']);

      notification.success({
        message: intl.formatMessage({
          id: 'tasks.application.modal.create.success.title',
        }),
        description: intl.formatMessage({
          id: 'tasks.application.modal.remove.success.description',
        }),
      });

      queryClient.invalidateQueries(['taskApplications']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
